<template>
  <Main>
    <template v-slot:toolbar>
      <div class="ghostWhite">
        <fragment v-if="show">
          <ToolbarCriticism
            class="max-content-width"
            :quotation="currentQuotation"
            :new-route="{ name: 'new criticism policy' }"
          />
        </fragment>
      </div>
    </template>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        :items="breadcrumb"
        @return="previousPage"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb :items="breadcrumb" @return="previousPage" />
    </template>
    <fragment v-if="show">
      <HeaderCriticism />
      <v-row v-for="(item, key) in listCriticism.criticas" :key="key">
        <CriticismMessage
          :item="item"
          :index="key"
          @resend="resendCriticism"
          @regularize="openModalRegularize"
          @answer="answerCriticism"
        />
      </v-row>
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeModal"
      :title="title"
      :text="text"
    />
    <ModalNewMessageCriticism
      v-model="modalAnswer"
      v-if="modalAnswer"
      @close="closeModalNewMessage"
      @submit="submitNewMessage"
    />
    <ModalRegularizeCriticism
      v-model="modalRegularize"
      @close="closeModalRegularize"
      title="REGULARIZAR CRÍTICA"
      text="Você deseja regularizar a crítica?"
      text-button="SIM"
      has-cancel-button
    />
  </Main>
</template>
<script>
import ToolbarCriticism from "../../quotation/components/ToolbarCriticism";
import CriticismMessage from "../../quotation/components/CriticismMessage";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalGenericCriticism from "../../quotation/components/ModalGenericCriticism";
import ModalRegularizeCriticism from "../../quotation/components/ModalGenericCriticism";
import HeaderCriticism from "@/components/HeaderCriticism";
import ModalNewMessageCriticism from "../../quotation/components/ModalNewMessageCriticism";
import _ from "lodash";
import PolicyMixin from "@/mixins/PolicyMixin";
export default {
  data: () => ({
    text: null,
    title: null,
    modal: false,
    breadcrumb: [
      {
        text: "Apólice - ",
        to: "quotation element"
      }
    ],
    show: false,
    mediumWidth: 960,
    modalAnswer: false,
    answerMessage: null,
    itemRegularize: null,
    modalRegularize: false
  }),
  components: {
    CriticismMessage,
    ToolbarCriticism,
    ModalGenericCriticism,
    HeaderCriticism,
    ModalNewMessageCriticism,
    ModalRegularizeCriticism
  },
  mixins: [LoadingRequest, PolicyMixin],
  created() {
    this.fetchPolicy();
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapState("quotation", ["listCriticism", "currentQuotation"]),
    ...mapState("policy", ["currentPolicy"]),
    quotationId() {
      return this.currentPolicy.cotacao?.id;
    },
    policyId() {
      return this.$route.params.id;
    },
    windowWidth() {
      return window.innerWidth;
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestListCriticism",
      "requestResolveCriticism",
      "requestResendCriticism",
      "requestCurrentQuotation",
      "requestNewCriticism"
    ]),
    ...mapActions("policy", ["requestCurrentPolicy"]),
    fetchQuotation() {
      this.withLoading(
        Promise.all([
          this.requestListCriticism(this.quotationId),
          this.requestCurrentQuotation(this.quotationId)
        ])
      );
    },
    fetchPolicy() {
      this.withLoading(this.requestCurrentPolicy(this.policyId));
    },
    resendCriticism(item) {
      this.withLoading(
        this.requestResendCriticism(this.getPayloadCriticism(item)).then(() => {
          this.modal = true;
          this.title = "MENSAGEM REENVIADA";
          this.text = "Um e-mail foi reenviado para o cliente";
        })
      );
    },
    regularizeCriticism() {
      this.withLoading(
        this.requestResolveCriticism(
          this.getPayloadCriticism(this.itemRegularize)
        ).then(() => {
          this.modal = true;
          this.title = "CRÍTICA REGULARIZADA";
          this.text =
            "O status da crítica foi atualizado. Visualize na tela da Cotação.";
        })
      );
    },
    async submitNewMessage(form) {
      this.closeModalNewMessage();
      this.withLoading(
        this.requestNewCriticism(await this.getPayloadNewCriticism(form)).then(
          () => {
            this.modal = true;
            this.title = "NOVA MENSAGEM";
            this.text = "Nova mensagem foi enviada com sucesso.";
          }
        )
      );
    },
    async getPayloadNewCriticism(form) {
      let payload = _.cloneDeep(form);
      payload.documentos = await this.submitFilesWithFormat(form.documentos);
      payload.critica_pai = { id: this.answerMessage.id };
      payload.tipo = _.cloneDeep(this.answerMessage.tipo);
      return {
        id: this.quotationId,
        payload: payload
      };
    },
    answerCriticism(id) {
      this.modalAnswer = true;
      this.answerMessage = id;
    },
    closeModalNewMessage() {
      this.modalAnswer = false;
    },
    closeModal() {
      this.modal = false;
      this.show = false;
      this.fetchQuotation();
    },
    previousPage() {
      this.$router.push({
        name: "details policy",
        params: { id: this.policyId }
      });
    },
    getPayloadCriticism(item) {
      return {
        cotacao: this.quotationId,
        critica: item.id
      };
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    updateBreadcrumb() {
      const quotation =
        this.windowWidth >= this.mediumWidth
          ? `, Cotação - ${this.currentPolicy?.cotacao?.numero}`
          : "";
      this.breadcrumb = [
        {
          text: `Apólice - ${this.currentPolicy?.numero}${quotation}`,
          to: "quotation element"
        }
      ];
    },
    closeModalRegularize(value) {
      this.modalRegularize = false;
      if (value) {
        this.regularizeCriticism();
      }
    },
    openModalRegularize(item) {
      this.itemRegularize = item;
      this.modalRegularize = true;
    }
  },
  watch: {
    currentPolicy() {
      this.updateBreadcrumb();
      this.fetchQuotation();
    },
    currentQuotation(value) {
      if (value) this.show = true;
    },
    windowWidth() {
      this.updateBreadcrumb();
    }
  }
};
</script>
